import React from 'react';

// Bank charges list for the payment pop-ups: rows grouped under section strips
// (Credit Card / Debit Card / UPI & Net Banking), an icon per payment mode and
// the charge shown as a pill. Takes the PG charges list as is:
// [{ Description, Value, isParent }]. Styled by the .bc-* rules in
// public/css/responsive-fixes.css.

const groupType = (title) => {
    if (/credit/i.test(title)) return 'credit';
    if (/debit/i.test(title)) return 'debit';
    return 'other';
};

const groupIcon = (type) => {
    if (type === 'other') return 'fa-university';
    return 'fa-credit-card';
};

const rowIcon = (desc) => {
    const d = desc || '';
    if (/master|visa|rupay|maestro/i.test(d)) {
        return <><i className="fa fa-cc-visa"></i><i className="fa fa-cc-mastercard"></i></>;
    }
    if (/diners/i.test(d)) return <i className="fa fa-cc-diners-club"></i>;
    if (/amex/i.test(d)) return <i className="fa fa-cc-amex"></i>;
    if (/international/i.test(d)) return <i className="fa fa-globe"></i>;
    if (/commercial/i.test(d)) return <i className="fa fa-briefcase"></i>;
    if (/upi/i.test(d)) return <i className="fa fa-mobile"></i>;
    if (/net\s*banking/i.test(d)) return <i className="fa fa-university"></i>;
    return <i className="fa fa-credit-card-alt"></i>;
};

// Splits the flat list into sections; UPI / Net Banking rows that follow the
// card sections get their own "UPI & Net Banking" strip
const toGroups = (list) => {
    const groups = [];
    let current = null;
    list.forEach((item) => {
        if (item.isParent) {
            current = { title: item.Description, type: groupType(item.Description), rows: [] };
            groups.push(current);
            return;
        }
        const isUpiOrNet = /upi|net\s*banking/i.test(item.Description || '');
        if (!current || (isUpiOrNet && current.type !== 'other')) {
            current = { title: isUpiOrNet ? 'UPI & Net Banking' : '', type: 'other', rows: [] };
            groups.push(current);
        }
        current.rows.push(item);
    });
    return groups;
};

const BankChargesTable = ({ list }) => {
    const rows = Array.isArray(list) ? list : [];
    if (rows.length === 0) {
        return <div className="bc-table"><div className="bc-empty">No Records Found...</div></div>;
    }
    return (
        <div className="bc-table">
            <div className="bc-head">
                <span>Payment Mode</span>
                <span>Bank Charges <small>(Plus GST)</small></span>
            </div>
            {toGroups(rows).map((group, gi) => (
                <div className={`bc-group bc-${group.type}`} key={gi}>
                    {group.title && (
                        <div className="bc-group-title">
                            <i className={`fa ${groupIcon(group.type)}`}></i>
                            {group.title}
                        </div>
                    )}
                    {group.rows.map((item, i) => (
                        <div className="bc-row" key={i}>
                            <span className="bc-icon">{rowIcon(item.Description)}</span>
                            <span className="bc-desc">{item.Description}</span>
                            <span className="bc-value">
                                <span className={`bc-pill ${/nil/i.test(item.Value || '') ? 'bc-pill-muted' : ''}`}>{item.Value}</span>
                            </span>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default BankChargesTable;
